import * as e from "react";
import { forwardRef as o } from "react";
const d = o(function(r, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12 3.51477V12.0001M12 12.0001V20.4853M12 12.0001H20.4853M12 12.0001H3.51471",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2
      }
    )
  );
});
export {
  d as AddLine
};
